import { ApiBase } from "../../../core/api-base";
import { z } from "zod";
import { GetItems200Response } from "../../../api/generated/users.zod";

type SearchUserModalApiResponse = z.infer<typeof GetItems200Response>;

export class SearchUserModalApi extends ApiBase {
    public static async searchUsers(query: string): Promise<SearchUserModalApiResponse> {
        const normalizedQuery = String(query || "").trim();
        const url = normalizedQuery
            ? `/api/v1/users?search=${encodeURIComponent(normalizedQuery)}&per_page=50`
            : "/api/v1/users?per_page=50";

        const response = await super.apiGet(url, { noSpinner: true });
        return (await response.json().catch(() => ({}))) as SearchUserModalApiResponse;
    }
}
